import React from 'react';
import PropTypes from 'prop-types';
import * as styles from './styles.css';

export default function Option({ label, display }) {
  return (
    <span
      data-testid={`select-option-${label}`}
      className={`${styles.option} ${display ? styles.display : ''}`}
    >
      <div>{label}</div>
    </span>
  );
}

Option.propTypes = {
  label: PropTypes.string.isRequired,
  display: PropTypes.bool.isRequired, // if view-only
};
